/**
 * PIN 5 — the theme, verbatim.
 *
 * These are the LIVE values taken from the mount sites' own overrides, not
 * `DOTPLAYER_CONFIG.DEFAULT_SETTINGS` (whose `fontColor` is `#ffffff` — four of
 * five sites override it to `#f2f2f2`).
 */
export const PLAYER_THEME = {
  fontColor: '#f2f2f2',
  fontColorHover: '#ffd43f',
  progressSliderMain: '#ffd43f',
  progressSliderBackground: '#aaaaaa',
  progressSliderBuffered: '#cccccc',
  controlBar: '#000000',
};

/**
 * Map a theme onto the CSS custom properties the vendored overlay reads.
 *
 * The property names are exactly the ones `bkfc-player.css` already uses — they
 * came from the vendor bundle and must not be renamed.
 *
 * @param {Partial<typeof PLAYER_THEME>} [overrides] - the `theme` prop
 * @returns {Record<string, string>} a React `style` object
 */
export function themeStyle(overrides) {
  const theme = { ...PLAYER_THEME, ...overrides };

  return {
    '--fontColor': theme.fontColor,
    '--fontColorHover': theme.fontColorHover,
    '--progressSliderMain': theme.progressSliderMain,
    '--progressSliderBackground': theme.progressSliderBackground,
    '--progressSliderBuffered': theme.progressSliderBuffered,
    '--controlBar': theme.controlBar,
  };
}

export default PLAYER_THEME;
